import {DateTime} from 'luxon';

export class CalcHelper {

  /**
   *
   * @param hours
   */
  public static hoursToMinutes(hours: number): number {
    if(hours === null) {
      return null;
    }

    return Math.round(hours * 60);
  }

  /**
   *
   */
  public static getValidHours(hours: number): number {
    return CalcHelper.minutesToHours(CalcHelper.hoursToMinutes(hours));
  }

  /**
   *
   * @param timeFrom
   * @param timeTo
   * @param minutes
   * @param roundMode
   */
  public static roundTimeTo(
    timeFrom: Date,
    timeTo: Date,
    minutes: number = 5,
    roundMode: 'nearest' | 'floor' | 'ceil' = 'nearest'
  ): Date {
    const diffMs = timeTo.getTime() - timeFrom.getTime();
    const diffMinutes = diffMs / (1000 * 60);

    // durch Intervall teilen
    const intervals = diffMinutes / minutes;

    let roundedIntervals: number;
    switch(roundMode) {
      case 'floor':
        roundedIntervals = Math.floor(intervals);
        break;
      case 'ceil':
        roundedIntervals = Math.ceil(intervals);
        break;
      default:
        roundedIntervals = Math.round(intervals);
        break;
    }

    // neue Differenz in Minuten
    const newDiffMinutes = roundedIntervals * minutes;

    // neues timeTo berechnen
    const newTimeTo = new Date(timeFrom.getTime() + newDiffMinutes * 60 * 1000);
    newTimeTo.setSeconds(0);
    newTimeTo.setMilliseconds(0);

    return newTimeTo;
  }


  public static roundTime(
    dateTime: string | Date | null,
    minutes: number = 5,
    roundMode: 'nearest' | 'floor' | 'ceil' = 'nearest'
  ): Date | null {
    if(!dateTime) return null;

    let dateObj: Date;

    if(typeof dateTime === 'string') {
      const dt = DateTime.fromISO(dateTime);
      if(!dt.isValid) return null;
      dateObj = dt.toJSDate();
    } else {
      dateObj = new Date(dateTime.getTime());
    }

    // 1. In Millisekunden umrechnen und Sekunden/MS nullen
    dateObj.setSeconds(0, 0);
    const ms = dateObj.getTime();
    const intervalMs = minutes * 60 * 1000;

    let roundedMs: number;

    // 2. Mathematische Rundung auf Basis des Zeitstempels
    switch(roundMode) {
      case 'floor':
        roundedMs = Math.floor(ms / intervalMs) * intervalMs;
        break;
      case 'ceil':
        roundedMs = Math.ceil(ms / intervalMs) * intervalMs;
        break;
      case 'nearest':
      default:
        roundedMs = Math.round(ms / intervalMs) * intervalMs;
        break;
    }

    return new Date(roundedMs);
  }


  /**
   *
   * @param value
   * @param decimal
   */
  public static round(value: number, decimal: number = 2): number {
    if(value === null) {
      return null;
    }
    let dividend = 1;
    for(let i = 0; i < decimal; i++) {
      dividend *= 10;
    }
    return Math.round(value * dividend) / dividend;
  }

  /**
   *
   * @param minutes
   */
  public static minutesToHours(minutes: number): number {
    if(minutes === null) {
      return null;
    }
    return Math.round(minutes / 60 * 100) / 100;
  }

  /**
   *
   * @param valueA
   * @param valueB
   */
  public static getPercentage(valueA: number, valueB: number): number {
    if(valueA === 0) {
      return null;
    }
    return Math.round((valueB / valueA) * 10000) / 100;
  }

  /**
   *
   */
  public static roundSeconds(dateTime: DateTime, roundMode: 'nearest' | 'floor' | 'ceil' = 'nearest'): DateTime {
    const seconds = dateTime.second;
    let newDateTime: DateTime;

    // Ensure milliseconds are always removed first to avoid rounding errors.
    dateTime = dateTime.set({millisecond: 0});

    switch(roundMode) {
      case 'floor':
        // Round down to the current minute (seconds to 0)
        newDateTime = dateTime.set({second: 0});
        break;

      case 'ceil':
        // Round up to the next minute, unless it is already exactly 0 seconds
        if(seconds === 0) {
          newDateTime = dateTime;
        } else {
          newDateTime = dateTime.plus({minutes: 1}).set({second: 0});
        }
        break;

      case 'nearest':
      default:
        // Rounds up or down based on the 30-second mark
        if(seconds >= 30) {
          newDateTime = dateTime.plus({minutes: 1}).set({second: 0});
        } else {
          newDateTime = dateTime.set({second: 0});
        }
        break;
    }

    return newDateTime;
  }

  /**
   * Parses a latitude/longitude value coming from the API or local storage.
   * The backend may deliver coordinates as strings; invalid or empty values become null.
   *
   * @param value
   */
  public static parseCoordinate(value: number | string | null | undefined): number | null {
    if(value === null || value === undefined || value === '') {
      return null;
    }

    const coordinate = typeof value === 'string' ? Number(value.trim().replace(',', '.')) : Number(value);

    return Number.isFinite(coordinate) ? coordinate : null;
  }

  /**
   *
   * @param dateTime
   */
  public static removeSeconds(dateTime: DateTime): DateTime {
    return dateTime.set({second: 0, millisecond: 0});
  }

}
